import { FC, useMemo } from "react";
import { CustomCellRendererProps } from "ag-grid-react";
import { Typography } from "@mui/material";
import { SavingsOpportunity } from "@/services/cloudchipr.api";
import { money } from "@/utils/numeral/money";
import {
  generateTotalFromUniqueItemsNodeByKey,
  SavingsOpportunityCostFieldKeys,
} from "@/components/pages/savings-opportunities/utils/helpers/generateTotalFromUniqueItemsByGridApiAndKey";

interface SavingsOpportunityMoneyGroupCell {
  color?: string;
  dataKey: SavingsOpportunityCostFieldKeys;
  node: CustomCellRendererProps<SavingsOpportunity>["node"];
}

export const SavingsOpportunityMonthlySavingsGroupCell: FC<
  SavingsOpportunityMoneyGroupCell
> = ({ node, dataKey, color }) => {
  const totalSavings = useMemo(() => {
    const children = node.allLeafChildren ?? [];

    const uniqueItemsCosts: Record<string, number> = {};

    children.forEach((node) =>
      generateTotalFromUniqueItemsNodeByKey(node, uniqueItemsCosts, dataKey),
    );

    return Object.values(uniqueItemsCosts).reduce((sum, num) => sum + num, 0);
  }, [node, dataKey]);

  return (
    <Typography variant="body2" color={color}>
      ~{money(totalSavings ?? 0)}
    </Typography>
  );
};
